import { useAuth } from '../auth/AuthContext';
import { api } from '../api/client';
import { LANGUAGES, markChosenBeforeSignIn, useLanguage, type Lang } from './i18n';

export default function LanguagePicker({ id = 'language' }: { id?: string }) {
  const { lang, setLang, t } = useLanguage();
  const { token } = useAuth();

  function choose(next: Lang) {
    setLang(next);
    if (!token) markChosenBeforeSignIn();
    if (token) void api('/me/settings', { method: 'PUT', token, body: { language: next } }).catch(() => undefined);
  }

  return (
    <div className="field language-picker">
      <label htmlFor={id}>{t('Language')}{lang !== 'en' && ' (Language)'}</label>
      <select id={id} value={lang} onChange={(e) => choose(e.target.value as Lang)}>
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code} lang={l.code}>
            {l.name}{l.code !== 'en' ? ` (${l.english})` : ''}
          </option>
        ))}
      </select>
      {lang !== 'en' && <span className="field-hint">{t('The games stay in English. Translations are being checked by native speakers.')}</span>}
    </div>
  );
}
